export const DEFAULT_PRIVACY_POLICY_URL = 'https://webmapp.it/privacy-policy/';
